export function dayStart(value) {
  const date = new Date(value);
  date.setHours(0, 0, 0, 0);
  return date;
}

export function dayEnd(value) {
  const date = new Date(value);
  date.setHours(23, 59, 59, 999);
  return date;
}
